<h3 mat-dialog-title >
    <b>Projeto</b> 
</h3>
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" style="width: 100%" fxFlex="100">
       <mat-label>Projeto</mat-label>
       <mat-select
            [(value)]="model.tipo_projeto_id"
            [formControl]="tipo_projeto_id">
            <mat-option value="">SELECIONE</mat-option>
            <mat-option *ngFor="let tipoProjeto of listaTipoProjeto"
                [value]="tipoProjeto.id">{{tipoProjeto.nome_projeto}}</mat-option>
       </mat-select>
       <mat-spinner diameter="20" *ngIf="loadingSpinnerTipoProjeto"></mat-spinner> 
    </mat-form-field>
</div>
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Descrição</mat-label>
        <input 
            matInput 
            placeholder="Descrição"
            aria-label="Descrição" 
            [formControl]="descricao" 
            maxlength="255">
    </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field style="width: 100%" appearance="outline" floatLabel="always">
        <mat-label>Quando</mat-label>
        <input 
            matInput 
            [matDatepicker]="dp"
            [min]="min_ano"
            placeholder="Ano - Mês" 
            [formControl]="quando"
        >
        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker 
            #dp 
            startView="multi-year" 
            (yearSelected)="chosenYearHandler($event)"
            (monthSelected)="chosenMonthHandler($event, dp)"
            panelClass="example-month-picker">
        </mat-datepicker>
    </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Valor Estimado</mat-label>
        <input matInput placeholder="Valor" [formControl]="valor"
            name="valor" maxlength="255" currencyMask
            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
    </mat-form-field>
</div>
 <div mat-dialog-actions style="text-align: center; margin-top: 20px;">
     <button 
         mat-button 
         tabindex="2" 
         (click)="onNoClick()">
         Cancelar
     </button>
     <button 
         mat-button 
         [disabled]="isInvalidForm()" 
         (click)="salvar()" 
         tabindex="-1">
         Salvar
     </button>
 </div>